<template>
  <form
    ref="login"
    @keyup.enter="submit()"
    v-on:submit.prevent=""
  >
    <h1>Login</h1>

    <div class="row row--separator row--separatorTop">
      <div class="row__full">
        <p v-if="errorMessage" class="row__error" v-html="errorMessage" />
        <p v-else>Login to access your personal Statzon account.<br>Or sign in to <span class="link" @click="goToAI()">Statzon AI</span> instead.</p>
      </div>
    </div>

    <div class="row row--separator">
      <div class="row__full">
        <FormInput
          :value="email"
          ref-name="email"
          placeholder="you@company.com"
          label="Email"
          alt-label="Valid email is required"
          type="email"
          class="form__input"
          autocomplete="username"
          :icon="icon.email"
          :error="errors.email"
          :status="status.email"
          @inputChanged="setFieldValue($event, 'email')"
          @unfocused="validate('email')"
        />
      </div>
    </div>

    <div class="row">
      <div class="row__full">
        <FormInput
          :value="password"
          ref-name="password"
          placeholder="*********"
          label="Password"
          alt-label="Minimum of 8 characters"
          class="form__input"
          type="password"
          autocomplete="current-password"
          :icon="icon.password"
          :error="errors.password"
          :status="status.password"
          @inputChanged="setFieldValue($event, 'password')"
          @unfocused="validate('password')"
        />
      </div>
    </div>

    <div class="row row--separator">
      <div class="row__full">
        <FormSubmit
          :status="formStatus"
          icon='<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm7.753 18.305c-.261-.586-.789-.991-1.871-1.241-2.293-.529-4.428-.993-3.393-2.945 3.145-5.942.833-9.119-2.489-9.119-3.388 0-5.644 3.299-2.489 9.119 1.066 1.964-1.148 2.427-3.393 2.945-1.084.25-1.608.658-1.867 1.246-1.405-1.723-2.251-3.919-2.251-6.31 0-5.514 4.486-10 10-10s10 4.486 10 10c0 2.389-.845 4.583-2.247 6.305z"/></svg>'
          @click="submit()"
        >
          {{ formStatus === 'success' ? 'Welcome ' + username + '!' : 'Sign in' }}
        </FormSubmit>
      </div>
    </div>

    <div class="row row--separator">
      <div class="row__full">
        <p class="row__notice">Forgot password? Click <router-link class="link" to="/login/forgot">here</router-link> to reset it.</p>
      </div>
    </div>
  </form>
</template>

<script>
import FormInput from '@/components/form/Input.vue'
import FormSubmit from '@/components/form/Submit.vue'

export default {
  components: {
    FormInput,
    FormSubmit
  },
  data () {
    return {
      form: false,
      formStatus: 'default',
      username: '',
      email: '',
      password: '',
      errorMessage: '',
      errors: {
        'email': false,
        'password': false
      },
      status: {
        'email': false,
        'password': false
      },
      icon: {
        email: '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M12 12.713l-11.985-9.713h23.971l-11.986 9.713zm-5.425-1.822l-6.575-5.329v12.501l6.575-7.172zm10.85 0l6.575 7.172v-12.501l-6.575 5.329zm-1.557 1.261l-3.868 3.135-3.868-3.135-8.11 8.848h23.956l-8.11-8.848z"/></svg>',
        password: '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M18 10v-4c0-3.313-2.687-6-6-6s-6 2.687-6 6v4h-3v14h18v-14h-3zm-5 7.723v2.277h-2v-2.277c-.595-.347-1-.984-1-1.723 0-1.104.896-2 2-2s2 .896 2 2c0 .738-.404 1.376-1 1.723zm-5-7.723v-4c0-2.206 1.794-4 4-4 2.205 0 4 1.794 4 4v4h-8z"/></svg>'
      }
    }
  },
  /*watch: {
    password: function (val, oldVal) {
      this.validate('password')
    }
  },*/
  methods: {
    async submit () {
      this.errorMessage = ''

      if (this.validate('all')) {
        this.formStatus = 'loading'

        let formData = {
          email: this.email,
          password: this.password
        }

        try {
          let response = await this.$store.dispatch('user/login', formData)
          this.username = response.data.attributes.first_name
          this.formStatus = 'success'
          this.$emit('loggedIn', true)
        } catch (error) {
          if (error.data) {
            if (error.data.errors.title) { this.errorMessage = error.data.errors.title }
          }
          this.formStatus = 'error'
        }
      }
    },
    validate (field) {
      let valid = true

      if (field === 'email' || field === 'all') {
        if (this.email === '') {
          this.errors.email = 'Required field'
          valid = false
        } else if (this.email.length > 255) {
          this.errors.email = 'Maximum of 255 characters'
          valid = false
        } else if (this.email !== '') {
          let emailTest = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          if (!emailTest.test(this.email)) {
            this.errors.email = 'Email must be valid'
            valid = false
          } else {
            this.errors.email = undefined
          }
        } else {
          this.errors.email = undefined
        }

        this.status.email = this.errors.email ? 'invalid' : 'valid'
      }

      if (field === 'password' || field === 'all') {
        if (this.password === '') {
          this.errors.password = 'Required field'
          valid = false
        } else if (this.password.length < 8) {
          this.errors.password = 'Minimum of 8 characters'
          valid = false
        } else {
          this.errors.password = undefined
        }

        this.status.password = this.errors.password ? 'invalid' : 'valid'
      }

      return valid
    },
    setFieldValue (value, field) {
      this[field] = value
    },
    goToAI () {
      window.location = 'https://ai.statzon.com'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

h1, h2 {
  @include font('header--xl', $white, 0.9);
  width: 90%;
  margin: 0 auto;
  text-align: center;

  @media screen and (min-width: $breakpointLg) {
    @include font('header--xxl', $white, 0.9);
    margin: 0 auto;
  }
}

p {
  @include font('content--md', $white);

  @media screen and (min-width: $breakpointLg) {
    @include font('content--lg', $white);
  }
}

</style>
